import { useLocale } from 'next-intl';

export const useLogoUrl = () => {
  const locale = useLocale();

  return `/images/logo/logo-${locale}.svg`;
};
